import pinterest from "web/script/embedded/pinterest";

export default {
    send: function (data) {
        data.forEach((event) => {
            if (event.type === "page_view") {
                pinterest();
            }
        });

        return Promise.resolve();
    },
};
